<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <main id="renew3_mypage">
      <div class="mypage_back mypage_yagioffer">
        <div class="wrapper">
          <h2 class="m-h2">マイページ</h2>
          <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
              class="text-link">旧マイページ</a>にアクセスしてください。</p>

          <div class="my-contents sp">

            <mypagemenu-item viewFlag="my"></mypagemenu-item>

            <!--contents-->
              <div class="my-contents_container">
                <h2 class="m-h2">ヤギオファー</h2>
                <p class="m-lead">指定した会社からはオファーを停止します。<br>
                  ※会社の名前は完全一致で判別します。<br>
                  ※オファーを受けたくない場合は <a href="/account/delete" class="text-link">こちら</a>
                </p>
                <ul class="list">
                  <li class="item" v-for="n in 10" :key="n">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <div class="flex item01-top">
                          <el-input type="textarea" autosize placeholder="会社名" title="会社名" v-model="ngCompanyNames"></el-input>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <br>
                <div class="yet-yagiprime-cv">
                  <button @click="goRegister()" id="prime-mypageprime-btn"
                    style="background: #E3165C;border-radius: 5px;color: #fff;font-weight: bold;width: 100%;padding: 15px 0;transition-duration: .4s;"><span>保存する</span></button>
                </div>

              </div>

            <mypagemenu-item viewFlag="service"></mypagemenu-item>

          </div>

          <div class="my-contents pc flex">
            <div class="menu-column">

              <mypagemenu-item viewFlag="my"></mypagemenu-item>

              <mypagemenu-item viewFlag="service"></mypagemenu-item>
            </div>

            <div class="right-contents">
              <!--contents-->
              <div class="my-contents_container">
                <h2 class="m-h2">ヤギオファー</h2>
                <p class="m-lead">指定した会社からはオファーを停止します。<br>
                  ※会社の名前は完全一致で判別します。<br>
                  ※オファーを受けたくない場合は <a href="/account/delete" class="text-link">こちら</a>
                </p>
                <ul class="list">
                  <li class="item" v-for="n in 10" :key="n">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <div class="flex item01-top">{{ n }}　：　
                          <el-input type="textarea" autosize placeholder="会社名" title="会社名" v-model="ngCompanyNames[n-1]"></el-input>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <br>
                <div class="yet-yagiprime-cv">
                  <button @click="saveNgCompanyname()" id="prime-mypageprime-btn"
                    style="background: #E3165C;border-radius: 5px;color: #fff;font-weight: bold;width: 100%;padding: 15px 0;transition-duration: .4s;"><span>保存する</span></button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<style lang="css" src="@/assets/css/renew3_mypage.css"></style>

<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

export default {
  components: {
    'mypagemenu-item': MypageCommonMenu,
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      dialogVisible: false,
      selectedYagiOfferData: {},
      yagiOfferData: [],
      ngCompanyNames: [],
      previewLoading: false,
      yagiOfferUnreadmessageList: [],
      chatURL: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    saveNgCompanyname: function () {
      const app = this
      console.error(this.ngCompanyNames)
      app.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', app.$firebase.user.uid)
      formData.append('ngcompany_name', JSON.stringify(app.ngCompanyNames))
      this.$axios
        .post(this.$varuna.endPoints.updateNgCompanyList, formData, { timeout: 60000 })
        .then(function (response) {

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    autoLink: function (text) {
      return text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'>$1</a>");
    },
    authStateChanged: async function () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', app.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.getNgCompanyList, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.ngcompany_name_datas)
          app.ngCompanyNames = response.data.ngcompany_name_datas

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {
    const app = this
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
